<template>
  <div class="user-status-filter">
    <h5 class="uk-text-bold mb-2">{{ label || $t('general.user_status') }}</h5>
    <div class="uk-flex uk-flex-middle uk-flex-wrap">
      <label v-for="option in options" :key="String(option.value)" class="uk-flex uk-flex-middle uk-margin-small-right">
        <input :checked="value === option.value" class="uk-radio" type="radio" @change="$emit('input', option.value)">
        <span class="uk-margin-small-left">{{ option.label }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserStatusFilter",
  props: {
    value: { default: null },
    label: { type: String, default: "" },
  },
  computed: {
    options() {
      return [
        { value: null, label: this.$t("general.all") },
        { value: 1, label: this.$t("general.active") },
        { value: 0, label: this.$t("general.inactive") },
      ];
    },
  },
};
</script>
